export default __webpack_public_path__ + "static/media/choletmini.83e4f778.jpg";